const iconClose = `
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g fill="none">
          <path d="M0 0h24v24H0z"/>
          <g stroke-width="2" fill-rule="evenodd" stroke="#7A8E96" stroke-linecap="square">
              <path d="M20.195 4.105 3.67 20.63M20.195 20.695 3.67 4.17"/>
          </g>
      </g>
  </svg>
`

export default iconClose
